import React from 'react';
import { CircleSlash } from 'lucide-react';

interface Props {
  label: string;
  selected: boolean;
  disabled: boolean;
  onSelect: () => void;
}

/** A one-click alternative to typing a number (e.g. "Would not buy"), set apart by an "or" divider. */
const NumericAltChoice: React.FC<Props> = ({ label, selected, disabled, onSelect }) => (
  <div className="space-y-4 pt-1">
    <div className="flex items-center gap-3 text-xs font-medium uppercase tracking-wider text-gray-400">
      <span className="h-px flex-1 bg-gray-200" />
      or
      <span className="h-px flex-1 bg-gray-200" />
    </div>
    <div className="flex justify-center">
      <button
        type="button"
        disabled={disabled}
        onClick={onSelect}
        aria-pressed={selected}
        className={`inline-flex items-center gap-2 rounded-full border px-5 py-2.5 text-sm font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-60 ${
          selected
            ? 'border-blue-600 bg-blue-50 text-blue-700'
            : 'border-gray-200 bg-gray-50 text-gray-600 hover:border-gray-300 hover:bg-gray-100 hover:text-gray-800'
        }`}
      >
        <CircleSlash className="h-4 w-4" aria-hidden="true" />
        {label}
      </button>
    </div>
  </div>
);

export default NumericAltChoice;
